<template>
  <div>
    <div class="pt-3 l-m-b-20 align-items-center d-flex justify-content-between blocks">
      <div class="d-flex align-items-center">
        <h1 class="pr-3 w-full">Contracts</h1>
        <div class="input-group search">
          <input class="form-control" type="text" v-model="q" @keyup="searchText($event)" placeholder="Search" />
          <button type="button" class="btn input-group-btn" @click="clearSearch">
            <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
          </button>
        </div>
      </div>
      <div class="text-right">
        <router-link tag="button" class="btn btn-primary btn-schedule" to="/contracts/create">
          <div class="fa fa-plus-square pr-1" />
          Create contract
        </router-link>
      </div>
    </div>
    <template v-if="contentLoading">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <div class="blocks">
        <ContractsBlock
          v-for="(contract, index) in contracts"
          :key="index"
          :contract.sync="contract"
        />
      </div>
      <div class="row blocks">
        <div class="col-sm-6 mb-1 text-black-50 pl-0"
             v-if="meta.total"
        >
          Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
        </div>
        <pagination class="col-sm-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
      </div>
    </template>
  </div>
</template>
<script>
import axios from 'axios';
import Pagination from '../Pagination';
import ContractsBlock from './ContractsBlock';

export default {
  name: 'Contracts',
  components: {
    ContractsBlock,
    Pagination,
  },
  data: () => ({
    page: 1,
    meta: [],
    q: '',
    contracts: [],
    contentLoading: false,
  }),
  created() {
    this.getContracts(this.page, this.q);
  },
  methods: {
    getContracts(page, q) {
      this.contentLoading = true;
      axios
        .get(`/contracts?page=${page}&q=${q}`)
        .then(res => {
          this.contracts = res.data.data;
          this.meta = res.data.meta;
        })
        .finally(() => {
          this.contentLoading = false;
        });
    },
    view(event, id) {
      this.$router.push(`/contracts/edit/${id}`);
    },
    changePage(pageNum) {
      this.page = pageNum;
      this.getContracts(this.page, this.q);
    },
    searchText(e) {
      this.page = 1;
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.filter();
        }, 500);
      }
    },
    search() {
      this.page = 1;
      this.filter();
    },
    filter() {
      this.getContractsSearch(this.page, this.q);
    },
    getContractsSearch(page, q) {
      axios.get(`contracts?page=${page}&q=${q}`).then(res => {
        this.contracts = res.data.data;
        this.meta = res.data.meta;
      });
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/contracts/Contracts.vue